import React from 'react';

import { List } from 'antd';

import { useUserPermission } from '@contexts/UserContext';

import { getBookCover } from '@libs/NwUtils';

import CreatedBy from '@components/CreatedBy/CreatedBy';
import AvatarBg from '@components/Gui/AvatarBg';
import { NwButton } from '@components/Gui/NwButton';

import { OtherBooksPublishedContainer } from './PlaylistPublishedWebsitesUI';
import { getPublishedBookItemKey, getPublishedBookPlaylist } from './publishedBooks.utils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const PublishedBookListItem = ({
    item,
    onRemove,
    removeDisabled = false,
    removeLoading = false,
}) => {
    const canPublishBooks = useUserPermission('PublishBooks');
    const playlist = getPublishedBookPlaylist(item);
    const canRemovePublication = Boolean(onRemove) && canPublishBooks;

    if (!playlist) {
        return null;
    }

    return (
        <List.Item
            key={getPublishedBookItemKey(item)}
            actions={
                canRemovePublication
                    ? [
                          <NwButton
                              iconOnly
                              ghost
                              disabled={removeDisabled || removeLoading}
                              loading={removeLoading}
                              icon={byPrefixAndName.fasl['trash-alt']}
                              onClick={() => onRemove(item)}
                          />,
                      ]
                    : []
            }
        >
            <List.Item.Meta
                avatar={<AvatarBg src={getBookCover(playlist)} />}
                title={`${playlist.Name?.toUpperCase() || ''}`}
                description={
                    <OtherBooksPublishedContainer>
                        <CreatedBy object={playlist} short textonly />
                        <p>
                            PUBLISHED AS <strong>{item.Role || '-'}</strong>
                        </p>
                    </OtherBooksPublishedContainer>
                }
            />
        </List.Item>
    );
};

export default PublishedBookListItem;
